<template>
  <v-layout>
    <SilderMultipurpose v-if="getterLogginIn"/>
    <navigation-component  v-if="getterLogginIn"/>
    <v-main>
      <navbar-component  v-if="getterLogginIn"/>
        <router-view />
      <v-footer app class="d-none d-md-block" height="40" id="footercentral">
        <v-col cols="12" class="mx-auto d-flex justify-space-between py-0 ">
          <span class="text-caption font-weight-bold">IMAGEN CORPORATIVA Y MARKETING - CETEMIN</span>
          <span class="text-caption font-weight-bold">Desarrollado por Equipo TIC - 2025 - v2</span>
        </v-col>
      </v-footer>
      <MenuBottomComponent v-if="$vuetify.display.xs && getterLogginIn" />
    </v-main>
    <v-overlay v-model="overlayLogin" class="app-overlay">
      <div class="overlay-brand-wrap">
        <v-img
          :src="require('@/assets/logo-image-mkt-negativo.svg')"
          width="400"
          max-width="400"
          contain
          style="filter: invert(1);"
        ></v-img>
        <div class="overlay-brand-sub">Marketing & Diseño</div>
        <div class="overlay-pulse" aria-hidden="true"></div>
      </div>
    </v-overlay>
  </v-layout>
</template>

<style lang="scss">
$navigation-drawer-scrim-opacity: 0.8 !important;
</style>

<script>

import NavbarComponent from "@/components/layouts/NavbarComponent.vue";
import NavigationComponent from "@/components/layouts/NavigationComponent.vue";
import MenuBottomComponent from "@/components/layouts/MenuBottomComponent.vue";
import SilderMultipurpose from "./components/layouts/SilderMultipurpose.vue";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import store from "./store";


export default {

  components: {
    NavbarComponent,
    NavigationComponent,
    MenuBottomComponent,
    SilderMultipurpose
  },
  computed:{
    ...mapGetters(["getterLogginIn"]),
    ...mapState(['overlayLogin']),
    
  },
  methods:{
    ...mapActions("configuracion/tipo", ["getAxiosTipo"]),
    ...mapActions("configuracion/categoria", ["getCategoriasAxios"]),
    ...mapActions("configuracion/subcategoria", ["getSubCategoriasAxios"]),
    ...mapActions("configuracion/prioridad", ["getPrioridadesAxios"]),
    ...mapActions("configuracion/estado", ["getEstadosAxios"]),
    ...mapActions('configuracion/sede', ['getSedesAxios']),
    ...mapActions('configuracion/agente', ['getAgentes']),
    ...mapActions('configuracion/notificacion', ['getConfigNotify']),
    ...mapActions('usuarios/roles', ['getAllRoles']),
    ...mapMutations(['setUser'])
  },
  created() {



    /**CARGA DE TODOS LOS RECURSOS NECESARIOS EN EL SISTEMA */
    this.getAxiosTipo();
    this.getPrioridadesAxios();
    this.getEstadosAxios();
    this.getCategoriasAxios();
    this.getSubCategoriasAxios();
    this.getSedesAxios();
    this.getAgentes();

    if(store.getters.getterLogginIn)
    {
      this.getConfigNotify();
      this.getAllRoles();

      //Necesario para cargar los roles
      store.commit('login/setUser', store.state.user)
      
    }
  },


};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap');

body{
  background-color: #ECEFF1 !important;
}

/* Overlay login moderno */
.app-overlay{
  background:
    radial-gradient(1200px 700px at 10% 20%, rgba(0, 86, 145, 0.55) 0%, rgba(0, 86, 145, 0) 60%),
    radial-gradient(900px 600px at 90% 35%, rgba(29, 78, 216, 0.45) 0%, rgba(29, 78, 216, 0) 65%),
    radial-gradient(900px 700px at 50% 110%, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0) 55%),
    linear-gradient(180deg, #030712 0%, #061a2a 55%, #020617 100%) !important;
  backdrop-filter: blur(0px);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Nuevo overlay: full-screen brand (sin “cuadro”) */
.overlay-brand-wrap{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px 18px;
}

.overlay-brand{
  font-weight: 1000;
  letter-spacing: 0.28em;
  text-indent: 0.28em;
  text-transform: uppercase;
  font-size: clamp(26px, 5vw, 44px);
  line-height: 1;
  color: transparent;
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.75) 30%, #A7C7FF 55%, #FFFFFF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  filter: drop-shadow(0 18px 40px rgba(0, 86, 145, 0.28));
  position: relative;
}

.overlay-brand::after{
  content: "";
  position: absolute;
  inset: -20px -40px -24px -40px;
  background: linear-gradient(110deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 35%, rgba(255,255,255,0) 70%);
  transform: translateX(-70%);
  animation: brandSweep 1.4s ease-in-out infinite;
  pointer-events: none;
  mix-blend-mode: screen;
}

@keyframes brandSweep{
  0%   { transform: translateX(-70%); opacity: 0; }
  25%  { opacity: 0.55; }
  50%  { opacity: 0.8; }
  75%  { opacity: 0.55; }
  100% { transform: translateX(70%); opacity: 0; }
}

.overlay-brand-sub{
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.55);
}

.overlay-pulse{
  width: min(380px, 72vw);
  height: 2px;
  border-radius: 999px;
  background: rgba(255,255,255,0.12);
  overflow: hidden;
  position: relative;
  margin-top: 6px;
}

.overlay-pulse::before{
  content: "";
  position: absolute;
  inset: 0;
  width: 40%;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(167,199,255,0.9) 55%, rgba(255,255,255,0) 100%);
  animation: pulseSlide 1s ease-in-out infinite;
}

@keyframes pulseSlide{
  0%   { transform: translateX(-60%); opacity: 0.2; }
  45%  { opacity: 1; }
  100% { transform: translateX(160%); opacity: 0.2; }
}
html{
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

#app {
  [class*='text-'] {
    -webkit-font-smoothing: antialiased;
    font-family: "Plus Jakarta Sans", sans-serif !important;
    text-rendering: optimizeLegibility;
    ;
  }

  -webkit-font-smoothing: antialiased;
  font-family: "Plus Jakarta Sans", sans-serif !important;
  text-rendering: optimizeLegibility;

}
.modern-elevated{
  box-shadow: 0 2px 6px #2553b91a !important
}
.bg-pattern{
  background-image: url('assets/bg-cetemin.jpg');
  background-repeat: repeat;
  background-size:cover;
  background-color: #0E2A3E;
}
.colorBlackTheme {
  color: #272829 !important;
}

.colorBlue1Theme {
  color: #19284e !important;
}

.colorBlue2Theme {
  color: #48589e !important;
}

.colorBlue3Theme {
  color: #858efa !important;
}

.colorLightTheme {
  color: #d2c9ff !important;
}

.bgBlackTheme {
  background-color: #12344D !important;
}

.bgBlue1Theme {
  background-color: #0E2A3E !important;
}

.bgBlue2Theme {
  background-color: #48589e !important;
}

.bgBlue3Theme {
  background-color: #858efa !important;
}

.bgLightTheme {
  background-color: #0E2A3E !important;
}

.bgLight2Theme {
  background-color: #F5F7F9 !important;
}

.bg-app {
  background-color: #EBEFF3 !important;
}

.bg-space{
  background-color: #FFFFFF !important;
}

.btn-system{
    height: 36px !important;
    border-radius: 4px !important;
    border: 1px solid #cfd7df !important;
    color: #12344d !important;
    cursor: pointer;
    padding: 2px 10px 3px 14px !important;
    margin-right: 2px;
    font-size: 14px !important;
    display: flex;
    align-content: center;
    -webkit-font-smoothing: antialiased;
    transition: .1s ease-in;
    background-image: linear-gradient(to bottom,#fff,#f3f5f7) !important;
    font-weight: 600 !important;

}

.btn-system >>> .v-btn--disabled.v-btn--variant-elevated{
  opacity: 0.5 !important;
}

.compact-full-input input.v-field__input {
  min-height: 36px !important;
  height: 36px !important;
  padding: 6px 10px !important;
  font-size: 12px;
  font-weight: 600;
}
.compact-full-input .v-field .v-field__input,
.compact-full-input  .v-field.v-field--variant-underlined .v-field__append-inner {
  padding: 10px 10px !important;
  min-height: 36px !important;
  height: 36px !important;
  font-size: 12px;
  font-weight: 600;
}


.solo-no-elevation .v-field--variant-solo, .v-field--variant-solo-filled {
  box-shadow: none !important;
}

.btn-float {
  position: fixed;
  bottom: 80px;
  right: 30px;
  z-index: 99;
}
/*
.loader {
  width: 20px;
  height: 12px;
  display: block;
  margin: auto;
  position: relative;
  border-radius: 4px;
  color: #FFF;
  background: currentColor;
  box-sizing: border-box;
  animation: animloader 0.6s 0.3s ease infinite alternate;
}
.loader::after,
.loader::before {
  content: '';  
  box-sizing: border-box;
  width: 20px;
  height: 12px;
  background: currentColor;
  position: absolute;
  border-radius: 4px;
  top: 0;
  right: 110%;
  animation: animloader  0.6s ease infinite alternate;
}
.loader::after {
  left: 110%;
  right: auto;
  animation-delay: 0.6s;
}*/

/* Loader legacy eliminado (ahora usamos v-progress-linear en el overlay) */

.v-btn--disabled.v-btn--variant-elevated, .v-btn--disabled.v-btn--variant-flat
{
  opacity: 0.2 !important;
}

.stamp {
  position: relative;
}

.stamp:before {
  position: absolute;
  top: -8px;
  display: block;
  content: "";
  background: radial-gradient(circle, transparent 8px, #fff 9px);
  background-size: 26px 40px;
  background-position: -20px -23px;
  width: 100%;
  height: 20px;
  z-index: 1;
}

.caja-texto-styles  ul, .caja-texto-styles  ol {
  margin-left: 30px !important;
}

.caja-texto-styles img {
  max-width: 100% !important;
}

.caja-texto-styles  table{
  border-collapse: collapse; /* Asegura que los bordes de las celdas se junten */
    width: 100%;
}

.caja-texto-styles table th, .caja-texto-styles table td{
  border: 2px solid #2f302f !important; /* Color y grosor del borde */
    padding: 8px; /* Espaciado interno de las celdas */
    text-align: left;
}



@keyframes animloader {
  0% {
    width: 20px;
  }
  100% {
    width: 48px;
  }
}


</style>


